export const types = {
    CONVERT: 'CONVERTING-TO-STRING',
    RANDOM:'RANDOM',
    SUM:'SUM',
    DIFFERENCE:'DIFFERENCE',
    ASSIGN: 'ASSIGN'
};